/**
 * SimplyBook.it Booking Modal Handler
 * Lädt das SimplyBook.it Widget in einem Modal
 */

(function () {
  'use strict';

  // Run on all secured pages
  if (!window.location.pathname.startsWith('/secure/user/')) {
    return
  }

  $(document).ready(function () {
    // Modal Event: Wenn Modal geöffnet wird
    $('#bookingModal').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget) // Button der das Modal öffnet
      const bookingUrl = button.attr('data-booking-url') || button.data('booking-url')
      
      if (bookingUrl) {
        // iFrame URL setzen und laden
        $('#bookingIframe').attr('src', bookingUrl)
        $('#bookingLoading').show()
        $('#bookingIframe').hide()
        
        // Warten bis iFrame geladen ist
        $('#bookingIframe').on('load', function() {
          $('#bookingLoading').hide()
          $('#bookingIframe').show()
        })
      }
    })
    
    // Modal Event: Wenn Modal geschlossen wird
    $('#bookingModal').on('hidden.bs.modal', function () {
      // iFrame URL zurücksetzen um Ressourcen freizugeben
      $('#bookingIframe').attr('src', '')
      $('#bookingLoading').hide()
      $('#bookingIframe').hide()
    })
  })
})()
